export default (value) => {
  return `${value}`.replace('.', ',')
}
